// extracted by mini-css-extract-plugin
export default {"Recipe":"Recipe_Recipe__UvsG5","copy":"Recipe_copy__ZUbhT"};